var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46509 2.69767C2.46509 2.31236 2.77745 2 3.16276 2H10.6046C10.9899 2 11.3023 2.31236 11.3023 2.69767V12C11.3023 12.3853 10.9899 12.6977 10.6046 12.6977H3.16276C2.77745 12.6977 2.46509 12.3853 2.46509 12V2.69767ZM3.86044 3.39535V11.3023H9.90695V3.39535H3.86044Z",
    fill: "#0049A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6976 2.69767C12.6976 2.31236 13.01 2 13.3953 2H20.8372C21.2225 2 21.5349 2.31236 21.5349 2.69767V8.27907C21.5349 8.66438 21.2225 8.97674 20.8372 8.97674H13.3953C13.01 8.97674 12.6976 8.66438 12.6976 8.27907V2.69767ZM14.093 3.39535V7.5814H20.1395V3.39535H14.093Z",
    fill: "#0049A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6976 11.0698C12.6976 10.6845 13.01 10.3721 13.3953 10.3721H20.8372C21.2225 10.3721 21.5349 10.6845 21.5349 11.0698V21.3023C21.5349 21.6876 21.2225 22 20.8372 22H13.3953C13.01 22 12.6976 21.6876 12.6976 21.3023V11.0698ZM14.093 11.7674V20.6047H20.1395V11.7674H14.093Z",
    fill: "#0049A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46509 14.7907C2.46509 14.4054 2.77745 14.093 3.16276 14.093H10.6046C10.9899 14.093 11.3023 14.4054 11.3023 14.7907V21.3023C11.3023 21.6876 10.9899 22 10.6046 22H3.16276C2.77745 22 2.46509 21.6876 2.46509 21.3023V14.7907ZM3.86044 15.4884V20.6047H9.90695V15.4884H3.86044Z",
    fill: "#0049A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDashboardIcon);
export default __webpack_public_path__ + "static/media/nav-dashboard-icon.874a322a78342b7ad27a37eca79d0966.svg";
export { ForwardRef as ReactComponent };